var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYouDidIt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 390.91 547.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f05223;}.cls-3{fill:#f4793b;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:#fce06a;}.cls-6{fill:#f8cd21;}.cls-7{fill:#8f1a1c;}.cls-8{isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 64.43,
    y1: -12.35,
    x2: 297.47,
    y2: 295.7,
    gradientTransform: "translate(0 36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea8224"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_you_did_it") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    className: "cls-1",
    d: "M388.55,186.65a61.52,61.52,0,0,0-14.2-24.4c-4.9-5.4-6.1-9-6.4-10.4v-.1a23.53,23.53,0,0,1,.2-11c1.2-3.2,8.8-24.9-5.1-45.7-12.5-18.8-31.2-23.4-35.2-24.1-2.4-.5-9.7-2.9-13.2-7.1a24.31,24.31,0,0,1-5.1-9l-.2-1.5c-1.7-9.9-10.6-28.8-33.4-36.7-19.4-6.7-34.3-1.7-41.4,1.9l-.1.1a11.94,11.94,0,0,1-5.2,1.4,26.22,26.22,0,0,1-5.7-.6,11.84,11.84,0,0,1-5-2.4l-1.1-1.1c-2.1-2.1-20.9-20-48.3-15.1-26.7,4.7-36.5,24.7-38.3,28.9a6.89,6.89,0,0,1-3.8,2.2,25.64,25.64,0,0,1-6.3,1.1l-1.6-.4c-2.9-.7-29.3-6.1-48.7,11.2-17.2,15.4-18.1,36-18,41.5-.1.9-.7,5.6-3.5,8.7l-1.5,1.7-1,2c-1.7,3.2-5.3,5.4-6.9,6.2-5.3,1.9-24.1,9.9-32.6,31.3v.1c-9.5,24.2,4.8,47,6.4,49.5l1,1.5a24,24,0,0,1,1,6c.2,2.7-.5,4-.8,4.4-3.1,3-18.5,19.2-13.6,46,5,27.6,28.6,38.8,31.2,40l-.1.2,1.2.3a13.35,13.35,0,0,1,4.2,4.1,22.08,22.08,0,0,1,2.5,4.8,13.68,13.68,0,0,1,.6,5.8c-.9,7.9-.4,23.5,12.6,39.4A51.21,51.21,0,0,0,83,355.55v191.6l112.5-84.5L308,547.15v-211c1.9-.6,4.6-1.2,9.2-2.3l3.1-.7a52.21,52.21,0,0,0,33.3-25.3,52.75,52.75,0,0,0,11.7-39.7c-.2-1.4-.3-2.8-.5-4-1.4-11.2-1.4-11.2.1-14.6,1.2-2.9,4.3-5.5,5.3-6.3,3.7-2.5,19.6-14.5,20.6-37.3A51.55,51.55,0,0,0,388.55,186.65ZM368.15,141a.1.1,0,0,1,.1-.1.77.77,0,0,0-.1.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-2",
    points: "195.46 218.85 195.46 437.65 290.06 508.65 290.06 218.85 195.46 218.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-3",
    points: "100.95 218.85 100.95 508.65 195.46 437.65 195.46 218.85 100.95 218.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M371.35,189.15a41.73,41.73,0,0,0-10.1-17.2c-3.6-3.9-9.2-10.9-10.9-19.2-2.5-12.3,1.1-21,1.1-21s6.1-15.3-3.3-29.4a38.75,38.75,0,0,0-23.8-16.5S309.65,83,301,72.75s-9.3-19.2-9.3-19.2S289,37.35,270.05,31c-13.2-4.5-22.9-1.3-27.5,1a29.92,29.92,0,0,1-13.4,3.4,41.17,41.17,0,0,1-10-1.2c-9.9-2.5-14.5-8.2-14.5-8.2s-13.5-13.5-32.5-10.1-24.9,18.3-24.9,18.3-3.3,9.1-15.5,12.4-16.7,1-16.7,1-19.6-4.5-32.6,7.1-12,28.3-12,28.3-.2,11.7-8.1,20.5C56.75,114,46,118.05,46,118.05s-15.9,4.9-22.3,21.2,4.7,33.1,4.7,33.1,3.9,3.3,4.9,15.9-6.3,18.9-6.3,18.9-11.8,10.8-8.4,29.9S39.45,264,39.45,264s7,2.4,12.8,10.8a38.41,38.41,0,0,1,4.6,9,31.71,31.71,0,0,1,1.5,13.7c-.6,5.2-.1,15.4,8.7,26.1,12.6,15.4,28.7,12.2,28.7,12.2s8.6-2.6,21.2,2,20.5,17.3,20.5,17.3a39.2,39.2,0,0,0,23.8,16.5c16.5,3.9,28.7-7.2,28.7-7.2s6.8-6.4,19.3-8.3c8.3-1.3,16.9,1.5,21.8,3.6a41.92,41.92,0,0,0,32.6.4,30.26,30.26,0,0,0,17.5-20.2,36.69,36.69,0,0,1,9.1-15.9c6.8-6.5,9.5-6.8,25.8-10.7a34.56,34.56,0,0,0,22.6-18h0c1.3-1.4,10.7-11.9,8.8-27.3-2-16.7-2.8-19.3,1-27.9s11.7-14,11.7-14a30.39,30.39,0,0,0,12.8-23.5A37.39,37.39,0,0,0,371.35,189.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    className: "cls-5",
    d: "M195.45,65.65a126.2,126.2,0,0,0-75.8,227.1L264.05,86A125.87,125.87,0,0,0,195.45,65.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    className: "cls-6",
    d: "M264.05,86l-144.4,206.8A126.19,126.19,0,1,0,264.05,86Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    className: "cls-7",
    d: "M195.45,324.55c-73.1,0-132.6-59.5-132.6-132.7a132.7,132.7,0,0,1,265.4,0C328.25,265.05,268.65,324.55,195.45,324.55Zm0-252.4a119.7,119.7,0,1,0,119.7,119.7C315.25,125.85,261.45,72.15,195.45,72.15Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.83,147.61v16.56H130V147.48l-18.09-30h11.48l12.48,20.77,12.49-20.77H159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.05,161.83a23.18,23.18,0,0,1-9.15-8.65,24.83,24.83,0,0,1,0-24.77,23.23,23.23,0,0,1,9.15-8.64,28.9,28.9,0,0,1,26.2,0,23.83,23.83,0,0,1,0,42.06,28.9,28.9,0,0,1-26.2,0Zm20.59-8a13.58,13.58,0,0,0,5.24-5.31,16.66,16.66,0,0,0,0-15.49,13.49,13.49,0,0,0-5.24-5.3,15.58,15.58,0,0,0-14.95,0,13.49,13.49,0,0,0-5.24,5.3,16.66,16.66,0,0,0,0,15.49,13.58,13.58,0,0,0,5.24,5.31,15.58,15.58,0,0,0,14.95,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.06,159.43q-5.58-5.55-5.58-15.83V117.43H228.3V143.2q0,12.56,10.41,12.56c3.38,0,6-1,7.75-3s2.67-5.2,2.67-9.52V117.43h10.68V143.6q0,10.29-5.58,15.83T238.65,165Q228.63,165,223.06,159.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.35,167.9h21.23A29.87,29.87,0,0,1,168,170.8a21.72,21.72,0,0,1,9.08,8.18,24.91,24.91,0,0,1,0,24.57,21.72,21.72,0,0,1-9.08,8.18,29.74,29.74,0,0,1-13.45,2.9H133.35Zm20.7,37.85q7,0,11.18-3.9c2.78-2.61,4.17-6.13,4.17-10.59s-1.39-8-4.17-10.58-6.51-3.9-11.18-3.9h-9.88v29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.5,167.9h10.81v46.73H188.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.4,167.9h21.23a29.93,29.93,0,0,1,13.45,2.9,21.78,21.78,0,0,1,9.08,8.18,24.91,24.91,0,0,1,0,24.57,21.78,21.78,0,0,1-9.08,8.18,29.8,29.8,0,0,1-13.45,2.9H210.4Zm20.69,37.85c4.68,0,8.4-1.3,11.19-3.9s4.17-6.13,4.17-10.59-1.39-8-4.17-10.58-6.51-3.9-11.19-3.9h-9.88v29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.81,219.52h10.82v46.74H167.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.39,228.33h-15v-8.81h40.73v8.81H210.21v37.93H199.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.87,265a5.76,5.76,0,0,1-1.83-4.31,5.57,5.57,0,0,1,1.8-4.23,7.06,7.06,0,0,1,9.21,0,5.57,5.57,0,0,1,1.8,4.23A5.76,5.76,0,0,1,241,265a6.8,6.8,0,0,1-9.15,0Zm-1.63-45.5h12.41L240.58,250H232.3Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYouDidIt);
export default __webpack_public_path__ + "static/media/icon_you_did_it.6d750d90f716540a737cbc1e7076738b.svg";
export { ForwardRef as ReactComponent };